import {useSetRecoilState} from 'recoil';
import {useQuery} from 'react-query';
import {colorDeclarations} from '../state/colorDeclarations';
import actions from '../api/colorDeclarations';

const useFetchColorDeclarations = () => {
  const setColorDeclarations = useSetRecoilState(colorDeclarations);
  return useQuery('fetchColorDeclarations', async () => {
    const colorDeclarations = await actions.fetchColorDeclarations();
    setColorDeclarations(colorDeclarations?.data);
    return colorDeclarations;
  });
};

export default useFetchColorDeclarations;
